import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Constants } from '../../../../../shared/utils/constants';

@Component({
  selector: 'app-mitigation-checkbox',
  templateUrl: './mitigation-checkbox.component.html',
  styleUrls: ['./mitigation-checkbox.component.css']
})
export class MitigationCheckboxRenderer implements ICellRendererAngularComp {
  public params: any;
  public columnThatModifies: any;
  public parent: any;
  public selectedValue!: boolean;
  public field!: string;

  agInit(params: any): void {
    this.params = params;
    this.columnThatModifies = params.columnThatModifies;
    this.parent = params.context;
    this.selectedValue = params.value;
    this.field = params.colDef.field;
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  public onChange(event: any) {
    this.parent.onCheckboxSelectionChanged({
      field: this.columnThatModifies,
      id: this.params.node.id,
      row: this.params.data,
      value: event.checked
    });
    this.params.api.refreshHeader();
    this.checkHeaderIfAllSelected(event);
  }

  checkHeaderIfAllSelected(event: any) {
    this.params.api.dispatchEvent({
      type: 'checkboxChanged',
      field: this.columnThatModifies
    });
  }

  isDisabled(): boolean {
    if ((this.params.data.location && this.params.data.location.includes('D')) && this.columnThatModifies.includes(Constants.FIELD_NAMES.RUN_OFF)) {
      return true;
    }

    return !this.params.isProjectOwnershipValid;
  }

}
